export * from './match-kick.interface';
